"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.startCheckSessionAsync = void 0;
const checkSessionIFrame_js_1 = require("./checkSessionIFrame.js");
const silentLogin_js_1 = require("./silentLogin.js");
// eslint-disable-next-line @typescript-eslint/ban-types
const startCheckSessionAsync = (oidc, oidcDatabase, configuration) => (checkSessionIFrameUri, clientId, sessionState, isSilentSignin = false) => {
    const silentLoginAsync = (extras, state = undefined, scope = undefined) => {
        return (0, silentLogin_js_1._silentLoginAsync)(oidc.configurationName, configuration, oidc.publishEvent.bind(oidc))(extras, state, scope);
    };
    return new Promise((resolve, reject) => {
        if (configuration.silent_login_uri && configuration.silent_redirect_uri && configuration.monitor_session && checkSessionIFrameUri && sessionState && !isSilentSignin) {
            const checkSessionCallback = () => {
                oidc.checkSessionIFrame.stop();
                const tokens = oidc.tokens;
                if (tokens === null) {
                    return;
                }
                const idToken = tokens.idToken;
                const idTokenPayload = tokens.idTokenPayload;
                return silentLoginAsync({
                    prompt: 'none',
                    id_token_hint: idToken,
                    scope: configuration.scope || 'openid',
                }).then((silentSigninResponse) => {
                    const iFrameIdTokenPayload = silentSigninResponse.tokens.idTokenPayload;
                    if (idTokenPayload.sub === iFrameIdTokenPayload.sub) {
                        const sessionState = silentSigninResponse.sessionState;
                        oidc.checkSessionIFrame.start(silentSigninResponse.sessionState);
                        if (idTokenPayload.sid === iFrameIdTokenPayload.sid) {
                            console.debug('SessionMonitor._callback: Same sub still logged in at OP, restarting check session iframe; session_state:', sessionState);
                        }
                        else {
                            console.debug('SessionMonitor._callback: Same sub still logged in at OP, session state has changed, restarting check session iframe; session_state:', sessionState);
                        }
                    }
                    else {
                        console.debug('SessionMonitor._callback: Different subject signed into OP:', iFrameIdTokenPayload.sub);
                    }
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                }).catch((e) => __awaiter(void 0, void 0, void 0, function* () {
                    console.warn('SessionMonitor._callback: Silent login failed, logging out other tabs:', e);
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    for (const [key, oidc] of Object.entries(oidcDatabase)) {
                        // @ts-ignore
                        yield oidc.logoutOtherTabAsync(configuration.client_id, idTokenPayload.sub);
                    }
                }));
            };
            oidc.checkSessionIFrame = new checkSessionIFrame_js_1.CheckSessionIFrame(checkSessionCallback, clientId, checkSessionIFrameUri);
            oidc.checkSessionIFrame.load().then(() => {
                oidc.checkSessionIFrame.start(sessionState);
                resolve(oidc.checkSessionIFrame);
            }).catch((e) => {
                reject(e);
            });
        }
        else {
            resolve(null);
        }
    });
};
exports.startCheckSessionAsync = startCheckSessionAsync;
//# sourceMappingURL=checkSession.js.map